import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { ROLE_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
}

const mutateAddRole = async ({ data }: mutateProps) => {
  return await axiosAuth.post(`${ROLE_API}`, data);
};

const useAddRoleMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddRole,
    ...queryParams,
  });

export default useAddRoleMutation;
